<!--团队管理新增-->
<template>
  <a-modal
    title="新增"
    style="top: 20px;"
    :width="800"
    v-model="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    :footer="false"
    :maskClosable="false"
  >
    <a-form :form="form" @submit="handleSubmit">
      <div style="margin-bottom: 20px">
        <a-form-item label="团队名称" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-right: 15px">
          <a-input
            style="width:50%"
            v-decorator="['teamName', { rules: [{ required: true, message: '请输入团队名称' }] }]"
          />
        </a-form-item>
        <a-form-item label="分单方式" :labelCol="labelCol" style="margin-right: 15px" :wrapperCol="wrapperCol">
          <a-select
            mode="multiple"
            style="width:50%"
            v-decorator="['divideOrder', { rules: [{ required: true, message: '请选择分单方式' }] }]"
            @change="handleChange"
          >
            <a-select-option value="0">
              自动分单
            </a-select-option>
            <a-select-option value="1">
              手动分单
            </a-select-option>
            <a-select-option value="2">
              抢单
            </a-select-option>
          </a-select>
        </a-form-item>
        <!-- <a-button v-if="show" class="twobtn" style="margin-top: 10px" type="primary" @click="Tomap">电子围栏</a-button> -->
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-item label="服务类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-checkbox-group
                v-decorator="[
                  'installType.installType',
                  { rules: [{ required: true, message: '请选择服务类别' }], initialValue: addd }
                ]"
                style="width: 400px;margin-top:5px;"
                @change="handleCheck11"
              >
                <a-checkbox v-for="type in restaurantTypes1" :value="type.code">
                  {{ type.label }}
                </a-checkbox>
              </a-checkbox-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="4"></a-col>
          <a-col :span="20">
            <a-form-item>
              <a-tabs ref="tabPane" @change="callback2" type="card">
                <a-tab-pane v-for="type in installTabs" :tab="type.label" :key="type.code">
                  <a-form-item label="标签" :labelCol="labelCol" :wrapperCol="wrapperCol" class="redItem">
                    <a-checkbox-group
                      v-decorator="['installLabelList' + '$' + type.code, { initialValue: getInitalValue(type.code) }]"
                      style="width: 400px;margin-top:5px;"
                      @change="handleCheck2"
                      :key="'installLabelList' + '$' + type.code"
                    >
                      <a-checkbox
                        @change="tabChecked"
                        v-for="item in data4[type.code]"
                        :value="item.installLabelId"
                        :key="type.code + item.installLabelId"
                      >
                        {{ item.installLabelName }}
                      </a-checkbox>
                    </a-checkbox-group>
                  </a-form-item>
                </a-tab-pane>
              </a-tabs>
            </a-form-item>
            <!--<a-form-item>-->
            <!--<a-tabs @change="callback2" type="card">-->
            <!--<a-tab-pane v-for="type in installTabs" :tab="type.label" :key="type.code">-->
            <!--<a-form-item label="标签"  :labelCol="labelCol" :wrapperCol="wrapperCol" class="redItem">-->
            <!--<a-checkbox-group-->
            <!--v-decorator="['installLabelList' + '$' + type.code, { initialValue: getInitalValue(type.code) }]"-->
            <!--style="width:400px;margin-top:5px;"-->
            <!--@change="handleCheck2"-->
            <!--:key="'installLabelList' + '$' + type.code"-->
            <!--&gt;-->
            <!--<a-checkbox v-for="item in data4[type.code]" :value="item.installLabelId" :key="type.code + item.installLabelId">-->
            <!--{{item.installLabelName}}-->
            <!--</a-checkbox>-->
            <!--</a-checkbox-group>-->
            <!--</a-form-item>-->
            <!--</a-tab-pane>-->
            <!--</a-tabs>-->
            <!--</a-form-item>-->
          </a-col>
        </a-row>
      </div>
      <a-affix :offsetBottom="50" style="margin-left:35%;margin-top: 20px;">
        <a-button style="margin-right: 100px;width:150px" type="primary" html-type="submit">提交</a-button>
        <a-button style="width:150px" @click="visible = false">取消</a-button>
      </a-affix>
    </a-form>
  </a-modal>
</template>

<script>
import { STable } from '@/components'
import { selectInstallTypeAndLabel } from '@/api/master/MasterList'
import { getDictMap } from '../../../utils/dict'
import { insert } from '@/api/master/TeamManagement'
import _ from 'lodash'
export default {
  name: 'TeamAdd',
  components: {
    STable
  },
  data() {
    return {
      masterId: '',
      installType: [],
      addd: [],
      form: this.$form.createForm(this),
      installTabs: [],
      data4: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      visible: false,
      restaurantTypes1: [],
      confirmLoading: false,
      queryParam: {},
      data: [],
      pagination: false,
      loading: false,
      columns: [
        {
          title: '序号',
          dataIndex: 'rowNum',
          width: '70px',
          align: 'center'
        },
        {
          title: '操作',
          width: '200px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center'
        },
        {
          title: '姓名',
          dataIndex: 'userName',
          align: 'center'
        },
        {
          title: '联系方式',
          dataIndex: 'userName',
          align: 'center'
        },
        {
          title: '登录平台',
          dataIndex: 'userName',
          align: 'center'
        },
        {
          title: '添加日期',
          dataIndex: 'sexName',
          align: 'center'
        },
        {
          title: '添加人',
          dataIndex: 'phonenumber',
          align: 'center'
        }
      ],
      loadData: parameter => {
        return queryMaster(Object.assign(parameter, this.queryParam))
      }
    }
  },
  async created() {
    this.restaurantOperTypeMap1 = await getDictMap('install_type')
    this.restaurantOperTypeMap1.forEach((value, key) => {
      this.restaurantTypes1.push({ code: key, label: value })
    })
    console.log(this.restaurantTypes1, '服务类别666')
  },
  methods: {
    callback2(key) {
      this.$nextTick(() => {
        this.$refs['tabPane'].activeKey = key
      })
    },
    handleCheck2(values) {
      console.log(values, 'values')
    },
    //服务类别change
    handleCheck11(values) {
      //alert(JSON.stringify(values))
      // alert(JSON.stringify(this.restaurantTypes1))
      // console.log(values)
      this.installTabs = []
      let that = this
      let arr = this.restaurantTypes1
      for (var j = 0; j < values.length; j++) {
        // console.log(values[j])
        for (var i = 0; i < arr.length; i++) {
          // console.log(arr[i],values[j])
          if (values[j] == arr[i].code) {
            let isList = {}
            isList.code = arr[i].code
            isList.label = arr[i].label
            this.installTabs.push(isList)
          }
        }
      }

      this.$nextTick(() => {
        if (this.installTabs.length > 0) {
          this.$refs['tabPane'].activeKey = this.installTabs[this.installTabs.length - 1].code
        }
      })
    },
    // handleCheck11(values){
    //   this.installTabs = []
    //   let that = this
    //   let arr = this.restaurantTypes1
    //   for (var j=0;j<values.length;j++){
    //     for(var i=0;i<arr.length;i++){
    //       if(arr[i].code == values[j]){
    //         let isList = {}
    //         isList.code = arr[i].code
    //         isList.label = arr[i].label
    //         this.installTabs.push(isList)
    //       }
    //     }
    //   }
    //   console.log(this.installTabs,'标签')
    // },
    getInitalValue(installType) {
      for (var item of this.installType) {
        if (item.installType == installType) {
          return item.installLabelList
        }
      }
    },
    add(id) {
      this.masterId = id
      this.form.resetFields()
      this.installTabs = []
      this.visible = true
      selectInstallTypeAndLabel().then(res => {
        this.data4 = res.data
      })
    },
    handleSubmit(e) {
      e.preventDefault()
      let tempInstalTypes = []
      this.form.validateFields((err, formValues) => {
        let values = _.cloneDeep(formValues)
        if (!err) {
          for (let installTypeIndex in formValues['installType']['installType']) {
            let installType = formValues['installType']['installType'][installTypeIndex]
            console.log(installType)
            for (let val in formValues) {
              const index = val.indexOf('$' + installType)
              if (index !== -1) {
                const tempValName = val.substr(0, index)
                let obj = {}
                obj['installType'] = installType
                obj[tempValName] = formValues[val]
                tempInstalTypes.push(obj)
                //values['installType']['installType'][installTypeIndex][tempValName] = values[val]
                delete values[val]
              }
            }
          }
          // values['installType']['installType'] = tempInstalTypes
          // for (let installTypeIndex in values['installType']['installType']) {
          //   let installType = values['installType']['installType'][installTypeIndex]
          //
          //   for (let val in values) {
          //     const index = val.indexOf('$' + installType)
          //     if (index !== -1) {
          //       const tempValName = val.substr(0, index)
          //       let obj = {}
          //       obj['installType'] = installType
          //       obj[tempValName] = values[val]
          //       tempInstalTypes.push(obj)
          //       delete values[val]
          //     }
          //   }
          // }
          delete values.installType
          values.installTypeDtosList = tempInstalTypes
          console.log(values)
          values.masterId = this.masterId
          insert(values)
            .then(res => {
              if (res.code === 0) {
                if (res.data) {
                  this.$message.success(res.data)
                } else {
                  this.$message.success('提交成功')
                  this.$emit('ok')
                  this.visible = false
                }
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped>
.ant-row {
  margin-top: 10px;
}
/deep/ .redItem .ant-form-item-label label {
  color: red;
}
.redItem .ant-checkbox-wrapper {
  color: red;
}
</style>
